export const getFormattedShortYearDate = (date) => {
  let day = date.getDate();
  let month = date.getMonth() + 1;
  const year = date.getFullYear();

  day = (day < 10 ? '0' : '') + day;
  month = (month < 10 ? '0' : '') + month;

  const formattedDay = `${day}.${month}.${year}`;

  return formattedDay;
};

export const getMinusHours = ({ date, hours }) => {
  const formattedDate = new Date(date);
  formattedDate.setHours(formattedDate.getHours() - hours);

  return formattedDate;
};

export const convertTermMonthsToDays = (term = {}) => {
  const convert = (value) =>
    typeof value === 'number' && !Number.isNaN(value) ? value * 30 : undefined;

  const { min, max } = term;

  return {
    minValue: convert(min),
    maxValue: convert(max),
  };
};
